/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(formData) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetActiveLicensesAndPendingApplicationsByTypeAndEntity: {
        $xmlns: 'http://dobs.pa.gov/nd/license/bpm/1.0',
        LicenseTypeID: formData.licenseTypeId,
        EntityID: formData.entityId
      }
    },
    blueprintArrays: [
      'GetActiveLicensesAndPendingApplicationsByTypeAndEntityResponse.Licenses.ND_License',
      'GetActiveLicensesAndPendingApplicationsByTypeAndEntityResponse.Applications.ND_Application'
    ],
    blueprint: {
      licenses: [
        '$..ND_License',
        {
          id: '$.ID',
          licenseNumber: '$.LicenseNumber',
          addressLine1: '$.AddressLine1',
          licenseType: '$.LicenseType'
        }
      ],
      applications: [
        '$..ND_Application',
        {
          id: '$.ID',
          addressLine1: '$.AddressLine1',
          applicationType: '$.ApplicationType'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject();
    });

  return defer.promise();
};
